import { Box } from '@mui/material';
import { H5 } from 'components/Typography';
const columnShape = [
    {
        Header: 'No',
        accessor: 'displayNumber',
        maxWidth: 10,
        Cell: ({ row }) => {
            return (
                <Box
                    sx={{
                        display: 'flex',
                    }}
                >
                    <H5 my={0}>{row.original.displayNumber}</H5>
                </Box>
            );
        },
    },
    {
        Header: 'Title',
        accessor: 'title',
        maxWidth: 430,
    },
    {
        Header: 'Judge 1',
        accessor: 'judge1',
        maxWidth: 50,
        Cell: ({ row }) => {
            const score = row.original.judgeScores?.[0]?.score ?? '-';
            const name = row.original.judgeScores?.[0]?.judgeName ?? '';
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                    title={name}
                >
                    <H5 my={0}>{score}</H5>
                </Box>
            );
        },
    },
    {
        Header: 'Judge 2',
        accessor: 'judge2',
        maxWidth: 50,
        Cell: ({ row }) => {
            const score = row.original.judgeScores?.[1]?.score ?? '-';
            const name = row.original.judgeScores?.[1]?.judgeName ?? '';
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                    title={name}
                >
                    <H5 my={0}>{score}</H5>
                </Box>
            );
        },
    },
    {
        Header: 'Judge 3',
        accessor: 'judge3',
        maxWidth: 50,
        Cell: ({ row }) => {
            const score = row.original.judgeScores?.[2]?.score ?? '-';
            const name = row.original.judgeScores?.[2]?.judgeName ?? '';
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                    title={name}
                >
                    <H5 my={0}>{score}</H5>
                </Box>
            );
        },
    },
    {
        Header: 'Final Score',
        accessor: 'averageScore',
        maxWidth: 70,
        Cell: ({ row }) => {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <H5 my={0}>{row.original.averageScore}</H5>
                </Box>
            );
        },
    },
];
export default columnShape;
